import { render, staticRenderFns } from "./peer_groups.vue?vue&type=template&id=580407ae&"
import script from "./peer_groups.vue?vue&type=script&lang=js&"
export * from "./peer_groups.vue?vue&type=script&lang=js&"
import style0 from "./peer_groups.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports